import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function ViralCarousel() {
  return (
    <ToolShell
      testid="tool-carousel-page" eyebrow="Tool" toolKey="carousel" title="Viral Carousel Builder"
      subtitle="A 7-10 slide carousel pack: cover, slides, final CTA slide, plus a long-form caption."
      endpoint="/tools/viral-carousel" tier="basic"
      fields={[
        { key: "topic", label: "What's the carousel about?", type: "textarea", rows: 3, required: true, placeholder: "e.g. 7 mistakes new divers make on their first ocean dive" },
        { key: "format", label: "Platform / format (optional)", type: "text", placeholder: "Instagram square, LinkedIn 4:5, etc." },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock label="Concept">{o.carousel_concept}</OutputBlock>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <OutputBlock label="Hook Archetype">{o.hook_archetype}</OutputBlock>
            <OutputBlock label="Psychological Trigger">{o.psychological_trigger}</OutputBlock>
          </div>
          {o.cover_slide && (
            <OutputBlock label="Cover Slide">
              <div className="space-y-2"><div className="font-semibold text-[#0A2342]">{o.cover_slide.headline}</div><div className="text-[#475569]">{o.cover_slide.subhead}</div><div className="text-xs text-[#64748B]">Visual: {o.cover_slide.visual_brief}</div></div>
            </OutputBlock>
          )}
          {(o.slides || []).map((s, i) => (
            <div key={`slide-${s.slide ?? i}-${(s.title || "").slice(0, 20)}`} className="dms-card p-5" data-testid={`slide-${s.slide}`}>
              <div className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#1D4E89]">Slide {s.slide}</div>
              <h3 className="mt-1 font-heading font-bold text-[16px] text-[#0A2342]">{s.title}</h3>
              <p className="mt-2 whitespace-pre-wrap leading-relaxed text-[14.5px]">{s.body}</p>
              {s.visual_brief && <div className="mt-2 text-xs text-[#64748B]">Visual: {s.visual_brief}</div>}
            </div>
          ))}
          {o.final_slide && <OutputBlock label="Final Slide / CTA"><div className="space-y-1"><div className="font-semibold">{o.final_slide.headline}</div><div>{o.final_slide.cta}</div></div></OutputBlock>}
          <OutputBlock label={`Caption (${(o.caption || "").length} chars)`} copyValue={o.caption}><div className="whitespace-pre-wrap leading-relaxed">{o.caption}</div></OutputBlock>
          {o.pinned_comment && <OutputBlock label="Pinned Comment" copyValue={o.pinned_comment}>{o.pinned_comment}</OutputBlock>}
        </>
      )}
    />
  );
}
